/**
 * Column widths shared by the "Quick discounts" and "All discounts" tables in
 * Settings → Discounts, so the two lists line up column for column. Actions
 * fits two ≥44px icon buttons (Edit + Delete) plus cell padding.
 */
export const DISCOUNT_TABLE_COLUMN_WIDTHS = {
  type: 160,
  amount: 120,
  actions: 124,
} as const;
